module.exports = __webpack_public_path__ + "static/media/LiveClassesEducation2.8b59fe8d.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/liveClass/LiveClassesEducation2.jpeg
// module id = 868
// module chunks = 7